var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-error",on:{"click":_vm.onClick}},[_c('svg-icon',{staticClass:"input-error-icon",attrs:{"name":"icon/new-design-error"}}),_vm._v(" "),_c('span',[_vm._v("\n    "+_vm._s(_vm.error)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }